exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-windex-js": () => import("./../../../src/pages/windex.js" /* webpackChunkName: "component---src-pages-windex-js" */),
  "component---src-templates-single-page-jsx": () => import("./../../../src/templates/single-page.jsx" /* webpackChunkName: "component---src-templates-single-page-jsx" */)
}

